import React from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { THEME_HEX, themeLabel } from '../../theme';

function ThemePieChart({ data }) {
  const rows = (data || []).map((d) => ({ name: themeLabel(d.theme), value: d.count, key: d.theme }));

  if (rows.every((r) => r.value === 0) || rows.length === 0) {
    return <p className="flex h-64 items-center justify-center text-sm text-slate-400">Sem dados no período.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie data={rows} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={2}>
          {rows.map((r) => (
            <Cell key={r.key} fill={THEME_HEX[r.key] || THEME_HEX[null]} />
          ))}
        </Pie>
        <Tooltip formatter={(value, name) => [`${value} notícias`, name]} />
        <Legend verticalAlign="bottom" height={36} iconType="circle" />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default ThemePieChart;
